module.exports = __webpack_public_path__ + "img/ch_flag.898de3aa.svg";